import React from 'react';
import PropTypes from 'prop-types';

import CybsButton from '@cybs-ui/components/lib/button';
import styles from './nest.styles';

const SelectedHeaderEl = selectedSectionHeader =>
  Object.keys(selectedSectionHeader).length > 0 ? (
    <div css={theme => styles(theme).selectedSectionWrapper}>
      <div
        key={`${selectedSectionHeader}-selected-header`}
        css={styles().selectedSectionHeader}
      >
        {selectedSectionHeader.value}
      </div>
      <div
        key={`${selectedSectionHeader}-selected-header-description`}
        css={styles().selectedSectionDescription}
      >
        {selectedSectionHeader.description}
      </div>
    </div>
  ) : null;

SelectedHeaderEl.displayName = 'SelectedHeaderEl';

const BackButton = ({ inputId, isBackShown, onBackClick }) => {
  const onBackKeyDown = (event, input) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      const inputEl = document.getElementById(input); // eslint-disable-line
      inputEl.focus();
    }
  };

  return isBackShown ? (
    <CybsButton
      colorScheme="tertiary"
      onClick={onBackClick}
      tabIndex="1" // eslint-disable-line
      css={styles().backButton}
      id={`${inputId}-back-button`}
      onKeyDown={e => onBackKeyDown(e, inputId)}
      iconClass="arrow-left"
      label="Back"
      resolution="low"
      iconLocation="left"
    />
  ) : null;
};

BackButton.propTypes = {
  inputId: PropTypes.string.isRequired,
  isBackShown: PropTypes.bool.isRequired,
  onBackClick: PropTypes.func.isRequired
};

BackButton.displayName = 'BackButton';

const DropdownNesting = ({
  children,
  childKey,
  onBackClick,
  isBackShown,
  selectedSectionHeader
}) =>
  children({
    backButton: inputId => BackButton({ inputId, isBackShown, onBackClick }),
    childKey,
    selectedHeaderEl: SelectedHeaderEl(selectedSectionHeader)
  });

DropdownNesting.displayName = 'DropdownNesting';

DropdownNesting.defaultProps = {
  childKey: 'children',
  isBackShown: false
};

DropdownNesting.propTypes = {
  children: PropTypes.node.isRequired,
  childKey: PropTypes.string,
  onBackClick: PropTypes.func.isRequired,
  isBackShown: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  selectedSectionHeader: PropTypes.object.isRequired
};

export default DropdownNesting;
